import { render, staticRenderFns } from "./asclogin.vue?vue&type=template&id=0cdeeda5&scoped=true&"
import script from "./asclogin.vue?vue&type=script&lang=js&"
export * from "./asclogin.vue?vue&type=script&lang=js&"
import style0 from "./asclogin.vue?vue&type=style&index=0&id=0cdeeda5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdeeda5",
  null
  
)

export default component.exports